<template>
  <t-default-entry-sidebar
    v-if="sidebarInfo"
    :sidebar-list="sidebarInfo.sidebarList"
    :sidebar-current="sidebarInfo.sidebarCurrent"
    :heading="sidebarInfo.heading"
    :sub-heading="sidebarInfo.subHeading"
    :sidebar-heading="sidebarInfo.sidebarHeading"
    :sidebar-sub-heading="sidebarInfo.sidebarSubHeading"
    :class="componentClassName"
  >
    <form v-if="show_form" class="t-application-invite-user-form-houjin__form" @submit.prevent="handleSubmitForm">
      <a-text>法人情報を記入してください</a-text>

      <div class="t-application-invite-user-form-houjin__fields">
        <m-form-input label="契約名義" type2="必須">
          <div class="t-application-invite-user-form-houjin__includeerror">
            <a-text-field
              id="companyName"
              v-model="formData.companyName"
              type="text"
              placeholder="NTTコミュニケーションズ株式会社"
              maxlength="40"
              required
              :error="getFieldError('companyName')"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.companyName.isError"
              v-html="backendErrorDict.companyName.msg"
              class="t-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="契約名義カナ" type2="必須">
          <div class="t-application-invite-user-form-houjin__includeerror">
            <a-text-field
              id="companyKanaName"
              v-model="formData.companyKanaName"
              type="text"
              placeholder="エヌティティコミュニケーションズカブシキガイシャ"
              maxlength="40"
              required
              :error="getFieldError('companyKanaName')"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.companyKanaName.isError"
              v-html="backendErrorDict.companyKanaName.msg"
              class="t-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <p class="m-form-input__label">登記事項証明書に記載の会社所在地をご入力ください。</p>
        <m-form-input label="郵便番号" type2="必須">
          <div class="t-application-invite-user-form-houjin__includeerror">
            <a-text-field
              id="companyPostCode"
              v-model="formData.companyPostCode"
              type="text"
              placeholder="1234567"
              maxlength="7"
              :error="getFieldError('companyPostCode')"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.companyPostCode.isError"
              v-html="backendErrorDict.companyPostCode.msg"
              class="t-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
          <template #note>
            <li>ハイフンは入れずにご入力ください。</li>
          </template>
        </m-form-input>
        <m-form-input label="都道府県名" type2="必須">
          <div class="t-application-invite-user-form-houjin__includeerror">
            <a-select-field
              id="-companyAddress1"
              v-model="formData.companyAddress1"
              placeholder="都道府県を選択してください"
              required
              :options="prefectures"
              :tabopen="tabopen"
              :error="getFieldError('companyAddress1')"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.companyAddress1.isError"
              v-html="backendErrorDict.companyAddress1.msg"
              class="t-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="市区町村" type2="必須">
          <div class="t-application-invite-user-form-houjin__includeerror">
            <a-text-field
              id="companyAddress2"
              v-model="formData.companyAddress2"
              type="text"
              placeholder="千代田区"
              maxlength="20"
              :error="getFieldError('companyAddress2')"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.companyAddress2.isError"
              v-html="backendErrorDict.companyAddress2.msg"
              class="t-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="字丁目番地など" type2="必須">
          <div class="t-application-invite-user-form-houjin__includeerror">
            <a-text-field
              id="companyAddress3"
              v-model="formData.companyAddress3"
              type="text"
              placeholder="大手町２－３－１"
              maxlength="20"
              :error="getFieldError('companyAddress3')"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.companyAddress3.isError"
              v-html="backendErrorDict.companyAddress3.msg"
              class="t-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="住所建物など" type="任意">
          <div class="t-application-invite-user-form-houjin__includeerror">
            <a-text-field
              id="companyAddress4"
              v-model="formData.companyAddress4"
              type="text"
              placeholder="大手町プレイスウエストタワー"
              maxlength="20"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.companyAddress4.isError"
              v-html="backendErrorDict.companyAddress4.msg"
              class="t-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
          <template #note>
            <li>建物名・部屋番号などがある場合は必ずご記入ください。</li>
          </template>
        </m-form-input>
        <m-form-input label="事業内容" type2="必須">
          <div class="t-application-invite-user-form-houjin__includeerror">
            <a-text-field
              id="companyBusinessDetails"
              v-model="formData.companyBusinessDetails"
              type="text"
              placeholder="通信事業など"
              maxlength="100"
              :error="getFieldError('companyBusinessDetails')"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.companyBusinessDetails.isError"
              v-html="backendErrorDict.companyBusinessDetails.msg"
              class="t-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <div class="m-form-input__note t-application-invite-user-form-houjin__note">
          <ul class="a-caption-list">
            <li>登記事項証明書の目的の中から代表的な事業内容を転記してください。</li>
          </ul>
        </div>

        <a-heading tag="h4" class="t-application-invite-company-contract__heading">
          実質的支配者について
          <a-button
            id="ownerLink"
            icon="help-outline"
            icon-color="black"
            :inline="true"
            :color="null"
            target="_blank"
            :href="authRulerUrl"
            title="別ウインドウにてPDF文書が表示されます。"
            @click="handleHelpClick"
            >(573KB)</a-button
          ><img src="/public/PDF_32.png" />
        </a-heading>

        <m-form-input label="実質的支配者の有無" type2="必須">
          <a-select-field
            id="-companyRulerFlag"
            v-model="formData.companyRulerFlag"
            placeholder="選択してください"
            :options="beneficial"
            :error="getFieldError('companyRulerFlag')"
          />
        </m-form-input>

        <!-- <h3 class="t-application-invite-user__term-title">
        </h3> -->
        <m-form-input label="実質的支配者名" type2="必須" icon-class="companyRuler">
          <div class="t-application-invite-user-form-houjin__includeerror">
            <a-text-field
              id="companyRulerName"
              v-model="formData.companyRulerName"
              type="text"
              placeholder="山田太郎"
              maxlength="40"
              :disabled="!flag"
              :error="getFieldError('companyRulerName')"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.companyRulerName.isError"
              v-html="backendErrorDict.companyRulerName.msg"
              class="t-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="実質的支配者住所" type2="必須" icon-class="companyRuler">
          <div class="t-application-invite-user-form-houjin__includeerror">
            <a-text-field
              id="companyRulerAddress"
              v-model="formData.companyRulerAddress"
              type="text"
              placeholder="東京都千代田区大手町２－３－１　大手町プレイスウエストタワー"
              maxlength="80"
              :disabled="!flag"
              :error="getFieldError('companyRulerAddress')"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.companyRulerAddress.isError"
              v-html="backendErrorDict.companyRulerAddress.msg"
              class="t-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="実質的支配者生年月日" type2="必須" icon-class="companyRuler">
          <div class="t-application-invite-user-form-houjin__includeerror">
            <a-text-field
              id="companyRulerBirthDate"
              v-model="formData.companyRulerBirthDate"
              type="text"
              placeholder="19800101"
              maxlength="8"
              :disabled="!flag"
              :error="getFieldError('companyRulerBirthDate')"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.companyRulerBirthDate.isError"
              v-html="backendErrorDict.companyRulerBirthDate.msg"
              class="t-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
          <template #note>
            <li>（例）1980年1月1日生まれの場合、19800101</li>
            <li>実質的支配者が法人の場合は、「20000101」とご記入ください。</li>
          </template>
        </m-form-input>
        <m-form-input label="実質的支配者の法人との関係" type2="必須" icon-class="companyRuler">
          <div class="t-application-invite-user-form-houjin__includeerror">
            <a-text-field
              id="companyRelationship"
              v-model="formData.companyRelationship"
              type="text"
              placeholder="役員"
              maxlength="20"
              :disabled="!flag"
              :error="getFieldError('companyRelationship')"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.companyRelationship.isError"
              v-html="backendErrorDict.companyRelationship.msg"
              class="t-application-invite-user-form-houjin__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <template v-for="(document, index) in companyRuler.inputs" :key="index">
          <div :id="'block_companyRuler' + (index + 2)" class="m-form-input">
            <div class="m-user-invitation-item__header" style="margin-bottom: 0px">
              <div class="m-user-invitation-item__header-title">
                <a-icon icon="user-outline" color="orange" />
                実質的支配者{{ index + 2 }}
              </div>
              <div class="m-user-invitation-item__header-action">
                <a-button
                  variant="round"
                  color="grey"
                  size="small"
                  :inline="true"
                  label="削除"
                  icon="trash"
                  icon-color="black"
                  @click="handleRemoveClick(index + 2)"
                />
              </div>
            </div>

            <m-form-input :label="'実質的支配者名' + (index + 2)" type2="必須" icon-class="companyRuler">
              <div class="t-application-invite-user-form-houjin__includeerror">
                <a-text-field
                  :id="'companyRulerName' + (index + 2)"
                  v-model="formData['companyRulerName' + (index + 2)]"
                  type="text"
                  placeholder="山田太郎"
                  maxlength="40"
                  :disabled="!flag"
                  :error="getFieldError('companyRulerName' + (index + 2))"
                />
                <!-- eslint-disable -->
                <a-text
                  v-if="backendErrorDict['companyRulerName' + (index + 2)].isError"
                  v-html="backendErrorDict['companyRulerName' + (index + 2)].msg"
                  class="t-application-invite-user-form-houjin__errormsg"
                />
                <!-- eslint-enable -->
              </div>
            </m-form-input>
            <m-form-input :label="'実質的支配者住所' + (index + 2)" type2="必須" icon-class="companyRuler">
              <div class="t-application-invite-user-form-houjin__includeerror">
                <a-text-field
                  :id="'companyRulerAddress' + (index + 2)"
                  v-model="formData['companyRulerAddress' + (index + 2)]"
                  type="text"
                  placeholder="東京都千代田区大手町２－３－１　大手町プレイスウエストタワー"
                  maxlength="80"
                  :disabled="!flag"
                  :error="getFieldError('companyRulerAddress' + (index + 2))"
                />
                <!-- eslint-disable -->
                <a-text
                  v-if="backendErrorDict['companyRulerAddress' + (index + 2)].isError"
                  v-html="backendErrorDict['companyRulerAddress' + (index + 2)].msg"
                  class="t-application-invite-user-form-houjin__errormsg"
                />
                <!-- eslint-enable -->
              </div>
            </m-form-input>
            <m-form-input :label="'実質的支配者生年月日' + (index + 2)" type2="必須" icon-class="companyRuler">
              <div class="t-application-invite-user-form-houjin__includeerror">
                <a-text-field
                  :id="'companyRulerBirthDate' + (index + 2)"
                  v-model="formData['companyRulerBirthDate' + (index + 2)]"
                  type="text"
                  placeholder="19800101"
                  maxlength="8"
                  :disabled="!flag"
                  :error="getFieldError('companyRulerBirthDate' + (index + 2))"
                />
                <!-- eslint-disable -->
                <a-text
                  v-if="backendErrorDict['companyRulerBirthDate' + (index + 2)].isError"
                  v-html="backendErrorDict['companyRulerBirthDate' + (index + 2)].msg"
                  class="t-application-invite-user-form-houjin__errormsg"
                />
                <!-- eslint-enable -->
              </div>
              <template #note>
                <li>（例）1980年1月1日生まれの場合、19800101</li>
                <li>実質的支配者が法人の場合は、「20000101」とご記入ください。</li>
              </template>
            </m-form-input>
            <m-form-input :label="'実質的支配者の法人との関係' + (index + 2)" type2="必須" icon-class="companyRuler">
              <div class="t-application-invite-user-form-houjin__includeerror">
                <a-text-field
                  :id="'companyRelationship' + (index + 2)"
                  v-model="formData['companyRelationship' + (index + 2)]"
                  type="text"
                  placeholder="役員"
                  maxlength="20"
                  :disabled="!flag"
                  :error="getFieldError('companyRelationship' + (index + 2))"
                />
                <!-- eslint-disable -->
                <a-text
                  v-if="backendErrorDict['companyRelationship' + (index + 2)].isError"
                  v-html="backendErrorDict['companyRelationship' + (index + 2)].msg"
                  class="t-application-invite-user-form-houjin__errormsg"
                />
                <!-- eslint-enable -->
              </div>
            </m-form-input>
          </div>
        </template>
        <div class="m-user-invitation-list__button">
          <a-button
            id="addItemBtn"
            variant="fill"
            color="primary"
            :disabled="!addCompanyRuler || !flag"
            size="small"
            label="実質的支配者追加"
            @click="handleAddItem"
          />
        </div>
      </div>
      <div class="t-application-invite-user-form-houjin__buttons">
        <m-button-container>
          <!--
          <a-button variant="block" submit="submit" color="primary" :disabled="hasError">次へ</a-button>
          -->
          <a-button id="next" variant="block" submit="submit" color="primary" :disabled="hasErrorflg">次へ</a-button>
          <a-button id="back" color="primary" @click="handleCancelClick">戻る</a-button>
        </m-button-container>
      </div>
    </form>
    <teleport to="body">
      <o-modal
        id="applicationInviteUserFormHoujin_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button id="ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-modal>
    </teleport>
  </t-default-entry-sidebar>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TDefaultEntrySidebar from '@/components/templates/default-entry-sidebar';
import MFormInput from '@/components/molecules/form-input';
import ATextField from '@/components/atoms/text-field';
import AButton from '@/components/atoms/button';
import MButtonContainer from '@/components/molecules/button-container';
import { cloneDeep } from 'lodash';
import OModal from '@/components/organisms/modal';
import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';
import { PREFECTURES, SIGNUP_RELIEF_MEASURES_PATH } from '@/libs/constants';

import { customValidate } from '@/common/customValidate.js'; // #2456

import { utils } from '@/common/utils.js';

export default {
  name: 't-application-invite-user-form-houjin',
  components: {
    TDefaultEntrySidebar,
    MFormInput,
    ATextField,
    AButton,
    MButtonContainer,
    OModal,
  },
  mixins: [messageContent, customRequest, customValidate], // #2456
  props: {
    class: {
      type: String,
      default: '',
    },
    // sidebarInfo: {
    //   type: Object,
    //   default: null,
    // },
    errorList: {
      type: Object,
      default: null,
    },
    handleFormSubmit: {
      type: Function,
      default: () => {},
    },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      hasErrorflg: true,
      // formData: {
      //   name: '',
      //   componay_name: '',
      //   phone_number: '',
      //   postal_code: '',
      //   street_address: '',
      //   email: '',
      //   password: '',
      //   password_confirm: '',
      // },
      formData: {
        companyName: '',
        companyKanaName: '',
        companyPostCode: '',
        companyAddress1: '',
        companyAddress2: '',
        companyAddress3: '',
        companyAddress4: '',
        companyBusinessDetails: '',
        companyRulerFlag: '',
        companyRulerName: '',
        companyRulerAddress: '',
        companyRulerBirthDate: '',
        companyRelationship: '',
        companyRulerName2: '',
        companyRulerAddress2: '',
        companyRulerBirthDate2: '',
        companyRelationship2: '',
        companyRulerName3: '',
        companyRulerAddress3: '',
        companyRulerBirthDate3: '',
        companyRelationship3: '',
        companyRulerName4: '',
        companyRulerAddress4: '',
        companyRulerBirthDate4: '',
        companyRelationship4: '',
      },
      sidebarInfo: {
        sidebarList: [
          { label: '契約情報の入力' },
          { label: '本人確認書類' },
          { label: '契約情報の入力(法人)' },
          { label: '法人の確認書類' },
          { label: '請求書送付先' },
          { label: 'お申し込み内容確認' },
        ],
        sidebarCurrent: 3,
        heading: '契約情報の入力(法人)',
        subHeading: 'Step 3',
        sidebarSubHeading: 'Sign Up',
        sidebarHeading: '新規お申し込み',
      },
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      tmpCompanyID: '',
      tmpDate: '',
      agree: false,
      flag: '',
      prefectures: [],
      authRulerUrl:
        'https://www.ntt.com/content/dam/nttcom/hq/jp/business/services/voice-visual-communication/callcenter-ivr/ccaas/pdf/for_business_hansyuhou.pdf#toolbar=0',
      beneficial: [
        {
          value: '',
          label: '選択してください',
        },
        {
          value: true,
          label: ' あり',
        },
        {
          value: false,
          label: 'なし',
        },
      ],
      show_form: false,
      tmpUUID: '',
      tmpYMD: '',
      // #2456
      spCharCheckListCompany: [
        {
          name: '契約名義',
          fieldName: 'companyName',
        },
        {
          name: '契約名義カナ',
          fieldName: 'companyKanaName',
        },
        {
          name: '郵便番号',
          fieldName: 'companyPostCode',
        },
        {
          name: '市区町村',
          fieldName: 'companyAddress2',
        },
        {
          name: '字丁目番地など',
          fieldName: 'companyAddress3',
        },
        {
          name: '住所建物など',
          fieldName: 'companyAddress4',
        },
        {
          name: '事業内容',
          fieldName: 'companyBusinessDetails',
        },
      ],
      spCharCheckListRuler: [
        {
          name: '実質的支配者名',
          fieldName: 'companyRulerName',
        },
        {
          name: '実質的支配者住所',
          fieldName: 'companyRulerAddress',
        },
        {
          name: '実質的支配者の法人との関係',
          fieldName: 'companyRelationship',
        },
        {
          name: '実質的支配者名2',
          fieldName: 'companyRulerName2',
        },
        {
          name: '実質的支配者住所2',
          fieldName: 'companyRulerAddress2',
        },
        {
          name: '実質的支配者の法人との関係2',
          fieldName: 'companyRelationship2',
        },
        {
          name: '実質的支配者名3',
          fieldName: 'companyRulerName3',
        },
        {
          name: '実質的支配者住所3',
          fieldName: 'companyRulerAddress3',
        },
        {
          name: '実質的支配者の法人との関係3',
          fieldName: 'companyRelationship3',
        },
        {
          name: '実質的支配者名4',
          fieldName: 'companyRulerName4',
        },
        {
          name: '実質的支配者住所4',
          fieldName: 'companyRulerAddress4',
        },
        {
          name: '実質的支配者の法人との関係4',
          fieldName: 'companyRelationship4',
        },
      ],
      companyRuler: {
        inputs: [
          {
            companyRulerName2: '',
            companyRulerAddress2: '',
            companyRulerBirthDate2: '',
            companyRelationship2: '',
          },
          {
            companyRulerName3: '',
            companyRulerAddress3: '',
            companyRulerBirthDate3: '',
            companyRelationship3: '',
          },
          {
            companyRulerName4: '',
            companyRulerAddress4: '',
            companyRulerBirthDate4: '',
            companyRelationship4: '',
          },
        ],
      },
      addCompanyRuler: true,
      backendErrorDict: {
        companyName: {
          isError: false,
          msg: '',
        },
        companyKanaName: {
          isError: false,
          msg: '',
        },
        companyPostCode: {
          isError: false,
          msg: '',
        },
        companyAddress1: {
          isError: false,
          msg: '',
        },
        companyAddress2: {
          isError: false,
          msg: '',
        },
        companyAddress3: {
          isError: false,
          msg: '',
        },
        companyAddress4: {
          isError: false,
          msg: '',
        },
        companyBusinessDetails: {
          isError: false,
          msg: '',
        },
        companyRulerName: {
          isError: false,
          msg: '',
        },
        companyRulerAddress: {
          isError: false,
          msg: '',
        },
        companyRulerBirthDate: {
          isError: false,
          msg: '',
        },
        companyRelationship: {
          isError: false,
          msg: '',
        },
        companyRulerName2: {
          isError: false,
          msg: '',
        },
        companyRulerAddress2: {
          isError: false,
          msg: '',
        },
        companyRulerBirthDate2: {
          isError: false,
          msg: '',
        },
        companyRelationship2: {
          isError: false,
          msg: '',
        },
        companyRulerName3: {
          isError: false,
          msg: '',
        },
        companyRulerAddress3: {
          isError: false,
          msg: '',
        },
        companyRulerBirthDate3: {
          isError: false,
          msg: '',
        },
        companyRelationship3: {
          isError: false,
          msg: '',
        },
        companyRulerName4: {
          isError: false,
          msg: '',
        },
        companyRulerAddress4: {
          isError: false,
          msg: '',
        },
        companyRulerBirthDate4: {
          isError: false,
          msg: '',
        },
        companyRelationship4: {
          isError: false,
          msg: '',
        },
      },
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      tabopen: 0,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-application-invite-user-form-houjin');
      return `${baseClassName} ${this.class}`.trim();
    },
    hasError() {
      let isValid = true;
      if (this.errorList) {
        isValid = !Object.keys(this.errorList).length > 0;
      }
      return isValid;
    },
  },
  async mounted() {
    // ページ移動、リロードダイアログ表示
    window.addEventListener('beforeunload', this.confirmMove);

    document.title = '契約情報の入力(法人) | COTOHA Call Center';

    utils.setMetaDescription(this.$route);
    await this.getCookie('tmpUUID');
    await this.getCookie('tmpYMD');

    const tmpCompanyID = this.tmpUUID;
    if (typeof tmpCompanyID === 'undefined') {
      this.$router.push({ path: SIGNUP_RELIEF_MEASURES_PATH });
      return; // #2314
    }

    this.show_form = true;

    try {
      this.prefectures = PREFECTURES;
      this.tmpCompanyID = this.tmpUUID;
      this.tmpDate = this.tmpYMD;
      if (!this.tmpCompanyID || !this.tmpDate) {
        throw new Error('Invalid data.');
      }
      const result = await this.getHistoryDoc(this.tmpCompanyID, this.tmpDate);

      this.formData.companyName = result.companyName;
      this.formData.companyKanaName = result.companyKanaName;
      this.formData.companyPostCode = result.companyPostCode;
      this.formData.companyAddress1 = result.companyAddress1;
      this.formData.companyAddress2 = result.companyAddress2;
      this.formData.companyAddress3 = result.companyAddress3;
      this.formData.companyAddress4 = result.companyAddress4;
      this.formData.companyBusinessDetails = result.companyBusinessDetails;
      let setDisplay = '';
      if (result.companyRulerFlag === false) {
        this.formData.companyRulerFlag = false;
        this.flag = false;
        setDisplay = 'none';
      } else if (result.companyRulerFlag === true) {
        this.formData.companyRulerFlag = result.companyRulerFlag;
        this.flag = true;
        setDisplay = 'inline-block';
      } else {
        this.flag = false;
        setDisplay = 'none';
      }

      const companyRuler = document.getElementsByClassName('companyRuler');
      for (let i = 0; i < companyRuler.length; i++) {
        companyRuler[i].style.display = setDisplay;
      }

      let companyRulerNo = '';
      for (let i = 0; i < 4; i++) {
        if (i > 0) {
          companyRulerNo = String(i + 1);
        }

        this.formData['companyRulerName' + companyRulerNo] = result['companyRulerName' + companyRulerNo];
        this.formData['companyRulerAddress' + companyRulerNo] = result['companyRulerAddress' + companyRulerNo];
        this.formData['companyRulerBirthDate' + companyRulerNo] = result[
          'companyRulerBirthDate' + companyRulerNo
        ].replace(/-/g, '');
        this.formData['companyRelationship' + companyRulerNo] = result['companyRelationship' + companyRulerNo];
      }

      // 入力項目表示制御
      let viewCompanyRuler = 0;
      for (let i = 4; i >= 2; i--) {
        if (
          this.formData['companyRulerName' + i] !== '' &&
          this.formData['companyRulerAddress' + i] !== '' &&
          this.formData['companyRulerBirthDate' + i] !== '' &&
          this.formData['companyRelationship' + i] !== ''
        ) {
          viewCompanyRuler = i;
          break;
        }
      }

      for (let i = 4; i >= 2; i--) {
        if (i > viewCompanyRuler) {
          document.getElementById('block_companyRuler' + i).style.display = 'none';
        }
      }

      if (viewCompanyRuler === 4) {
        this.addCompanyRuler = false;
      }
    } catch (error) {
      console.log(error);
      this.showErrorModal(messageContent.requireTry('情報取得'));
    }
  },
  unmounted() {
    // ページ移動、リロードダイアログ解除
    window.removeEventListener('beforeunload', this.confirmMove);
  },
  methods: {
    confirmMove(e) {
      e.returnValue = '他のページに移動しますか？';
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    handleSubmitForm(e) {
      e.preventDefault();

      // #2456
      for (const item of this.spCharCheckListCompany) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.formData[item.fieldName] })) {
          const errMsg = messageContent.requireNotSpecialCharacter(item.name);
          this.setBackendErrorMsg([{ param: item.fieldName, msg: errMsg }]);
          this.showErrorModal(errMsg);
          return;
        }
      }
      if (this.formData.companyRulerFlag === true) {
        for (const item of this.spCharCheckListRuler) {
          if (this.hasSpecialCharacterInObject({ keyWord: this.formData[item.fieldName] })) {
            const errMsg = messageContent.requireNotSpecialCharacter(item.name);
            this.setBackendErrorMsg([{ param: item.fieldName, msg: errMsg }]);
            this.showErrorModal(errMsg);
            return;
          }
        }
      }

      const set_Data = Object.assign({}, this.formData);
      let companyRulerNo = '';
      for (let i = 0; i < 4; i++) {
        if (i > 0) {
          companyRulerNo = String(i + 1);
        }

        const tmp_companyRulerBirthDate = this.formData['companyRulerBirthDate' + companyRulerNo];
        if (tmp_companyRulerBirthDate !== '') {
          const y = tmp_companyRulerBirthDate.substr(0, 4);
          const m = tmp_companyRulerBirthDate.substr(4, 2);
          const d = tmp_companyRulerBirthDate.substr(6);
          const value = y + '-' + m + '-' + d;
          set_Data['companyRulerBirthDate' + companyRulerNo] = value;
        }
      }

      const formDataTmp = {
        tmpCompanyID: this.tmpCompanyID,
        date: this.tmpDate,
        data: set_Data,
        _csrf: this.csrfToken,
      };
      const formData = JSON.stringify(formDataTmp);
      fetch('/signup/updatehoujinhistorydoc', {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          if (response.status === 403) {
            window.location.href = SIGNUP_RELIEF_MEASURES_PATH;
            return {};
          } else {
            return response.json();
          }
        })
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              if (Array.isArray(e.errors)) {
                this.setBackendErrorMsg(e.errors);
                const errMsg = e.errors.map(e => e.msg).join('<br />');
                this.showErrorModal(errMsg);
                return {};
              } else if (e.msg) {
                this.showErrorModal(e.msg);
                return {};
              } else {
                throw new Error('/signup/updatehoujinhistorydoc response was not ok.');
              }
            }

            this.$router.push({ name: 'SignupUploadH' });
            return {};
          } else {
            window.location.href = SIGNUP_RELIEF_MEASURES_PATH;
            return {};
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.requireTry('法人情報の登録'));
        });
    },
    // エラーリストを更新（引数無しで呼び出すとエラーを全て空にする）
    setBackendErrorMsg(errors) {
      Object.keys(this.backendErrorDict).forEach(fieldName => {
        this.backendErrorDict[fieldName].isError = false;
        this.backendErrorDict[fieldName].msg = '';
      });
      if (!Array.isArray(errors)) return;
      for (const error of errors) {
        if (typeof error.param !== 'string') continue;
        const fieldName = error.param.split('.').slice(-1)[0];
        const target = this.backendErrorDict[fieldName];
        target.isError = true;
        target.msg += target.msg === '' ? error.msg : `<br />${error.msg}`;
      }
    },
    getFieldError(key) {
      if (key === 'companyRulerFlag') {
        let setDisplay = '';
        if (this.formData.companyRulerFlag === true) {
          this.flag = true;
          setDisplay = 'inline-block';
        } else if (this.formData.companyRulerFlag === false) {
          this.flag = false;
          setDisplay = 'none';
        } else {
          this.flag = false;
          setDisplay = 'none';
        }

        const companyRuler = document.getElementsByClassName('companyRuler');
        for (let i = 0; i < companyRuler.length; i++) {
          companyRuler[i].style.display = setDisplay;
        }
      }

      this.hasErrorflg = false;

      const arrInput = [
        'companyName',
        'companyKanaName',
        'companyPostCode',
        'companyAddress1',
        'companyAddress2',
        'companyAddress3',
        'companyBusinessDetails',
      ];

      const arrInput2 = [];
      arrInput2[0] = ['companyRulerName', 'companyRulerAddress', 'companyRulerBirthDate', 'companyRelationship'];
      arrInput2[1] = ['companyRulerName2', 'companyRulerAddress2', 'companyRulerBirthDate2', 'companyRelationship2'];
      arrInput2[2] = ['companyRulerName3', 'companyRulerAddress3', 'companyRulerBirthDate3', 'companyRelationship3'];
      arrInput2[3] = ['companyRulerName4', 'companyRulerAddress4', 'companyRulerBirthDate4', 'companyRelationship4'];

      for (let i = 0; i < arrInput.length; i++) {
        if (this.formData[arrInput[i]] === '') {
          this.hasErrorflg = true;
          return;
        }
      }

      if (this.formData.companyRulerFlag === true) {
        let chk_input = false;
        for (let j = 0; j < 4; j++) {
          let chk_cnt = 0;
          for (let i = 0; i < arrInput2[j].length; i++) {
            if (this.formData[arrInput2[j][i]] !== '') {
              chk_cnt++;
              chk_input = true;
            }
          }

          if (chk_cnt > 0 && chk_cnt < 4) {
            this.hasErrorflg = true;
            return;
          }
        }

        if (chk_input === false) {
          this.hasErrorflg = true;
          return;
        }
      }

      if (this.flag === '') {
        this.hasErrorflg = true;
        return;
      }

      if (this.formData.companyRulerFlag === '') {
        this.hasErrorflg = true;
        return;
      }
      /*
      if (this.errorList && this.errorList[key]) {
        return this.errorList[key];
      }
      return null;
*/
    },
    handleCancelClick() {
      this.$router.push({ name: 'SignupUpload' });
    },
    getHistoryDoc(tmpCompanyID, date) {
      const formDataTmp = {
        tmpCompanyID: tmpCompanyID,
        date: date,
        _csrf: this.csrfToken,
      };
      const formData = JSON.stringify(formDataTmp);
      return fetch('/signup/gethistorydoc', {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          if (response.status === 403) {
            window.location.href = SIGNUP_RELIEF_MEASURES_PATH;
            return {};
          } else {
            return response.json();
          }
        })
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              throw new Error('/signup/gethistorydoc response was not ok.');
            }
            return e.result;
          } else {
            window.location.href = SIGNUP_RELIEF_MEASURES_PATH;
            return {};
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.requireTry('法人情報の登録'));
        });
    },
    getCookie: async function (key) {
      await this.postRequest('/signup/getCookie', { key: key })
        .then(e => {
          this[key] = e.cookie_value;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('情報取得'));
        });
    },
    handleAddItem() {
      for (let i = 2; i <= 4; i++) {
        this.addCompanyRuler = true;
        if (i === 4) {
          this.addCompanyRuler = false;
        }

        if (document.getElementById('block_companyRuler' + i).style.display === 'none') {
          document.getElementById('block_companyRuler' + i).style.display = 'block';
          break;
        }
      }
    },
    handleRemoveClick(removeNo) {
      const arrInput = ['companyRulerName', 'companyRulerAddress', 'companyRulerBirthDate', 'companyRelationship'];

      if (removeNo === 2) {
        for (let i = 0; i < arrInput.length; i++) {
          this.formData[arrInput[i] + removeNo] = this.formData[arrInput[i] + (removeNo + 1)];
          this.formData[arrInput[i] + (removeNo + 1)] = this.formData[arrInput[i] + (removeNo + 2)];
          this.formData[arrInput[i] + (removeNo + 2)] = '';
        }

        if (document.getElementById('block_companyRuler' + (removeNo + 2)).style.display !== 'none') {
          document.getElementById('block_companyRuler' + (removeNo + 2)).style.display = 'none';
        } else if (document.getElementById('block_companyRuler' + (removeNo + 1)).style.display !== 'none') {
          document.getElementById('block_companyRuler' + (removeNo + 1)).style.display = 'none';
        } else {
          document.getElementById('block_companyRuler' + removeNo).style.display = 'none';
        }
      } else if (removeNo === 3) {
        for (let i = 0; i < arrInput.length; i++) {
          this.formData[arrInput[i] + removeNo] = this.formData[arrInput[i] + (removeNo + 1)];
          this.formData[arrInput[i] + (removeNo + 1)] = '';
        }

        if (document.getElementById('block_companyRuler' + (removeNo + 1)).style.display !== 'none') {
          document.getElementById('block_companyRuler' + (removeNo + 1)).style.display = 'none';
        } else {
          document.getElementById('block_companyRuler' + removeNo).style.display = 'none';
        }
      } else {
        for (let i = 0; i < arrInput.length; i++) {
          this.formData[arrInput[i] + removeNo] = '';
        }
        document.getElementById('block_companyRuler' + removeNo).style.display = 'none';
      }

      this.addCompanyRuler = true;
    },
  },
};
</script>
